export const logo = "/img/logo/pulsenew.png"

export const error404 = "/img/other/error404.svg"

export const facebook = "/img/other/facebook.svg"
export const linkedin = "/img/other/linkedin.svg"
export const tumblr = "/img/other/tumblr.svg"

export const copy = "/img/other/copy.svg"
export const pp = "/img/other/pp.svg"
export const save = "/img/other/save.svg"
export const loading = "/img/other/loading.svg"
export const uploaded = "/img/other/uploaded.svg"
export const menu = "/img/other/menu.svg"
export const userIcon = "/img/other/user.svg"
export const canceldp = "/img/other/canceldp.svg"

export const chrome = "/img/other/chrome.svg"
export const browser = "/img/other/browser.svg"
export const edge = "/img/other/edge.svg"
export const firefox = "/img/other/firefox.svg"
export const safari = "/img/other/safari.svg"
export const opera = "/img/other/opera.svg"

export const approved = "/img/other/approved.svg"

export const arrowBtn = "/img/other/arrow-btn.svg"

export const diamondTransparent = "/img/other/diamond-Transparent.svg"

export const subscribe = "/img/other/subscribe.svg"
export const verified = "/img/other/verified.svg"
export const unverified = "/img/other/unverified.png"

export const bell = "/img/other/bell.svg"

export const usdt = "/img/other/USDT.svg"
export const usdtRound = "/img/other/usdtround.svg"
export const pusd = "/img/other/PUSD.svg"
export const ausd = "/img/other/AUSD.svg"
export const xpl = "/img/other/XPL.svg"
export const xplRound = "/img/other/XPLRound.svg"
export const paybycard = "/img/other/paybycard.svg"
export const quantIcon = "/img/other/quantIcon.svg"

export const xplBG = "/img/other/XPLBg.svg"

export const darkBlue = "/img/other/dark-blue.svg"

export const horiontalLine = "/img/other/horizontal-line.svg"
export const verticalLine = "/img/other/vertical-line.svg"

export const rankDepositDiamond = "/img/other/rank-deposit-diamond.svg"
export const rankDepositDiamond2 = "/img/other/rank-deposit-diamond-2.svg"

export const verifiedCheck = "/img/other/verifiedCheck.svg"

export const user_default = "/img/other/user.png"
export const closeWhite = "/img/other/close-white.png"

export const appstore = "/img/other/appstore.png"
export const playstore = "/img/other/playstore.png"

export const claimable = "/img/other/claimable.svg"
export const totalBalance = "/img/other/total-balance.svg"
export const dottedCorner = "/img/other/dotted-corner.svg"

export const upload = "/img/other/upload.svg"
